import { render, staticRenderFns } from "./nvaline.vue?vue&type=template&id=54bc0a4a&scoped=true"
import script from "./nvaline.vue?vue&type=script&lang=js"
export * from "./nvaline.vue?vue&type=script&lang=js"
import style0 from "./nvaline.vue?vue&type=style&index=0&id=54bc0a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc0a4a",
  null
  
)

export default component.exports